import { component as defineComponent } from 'flightjs';

function Accordion() {
    this.defaultAttrs({
        accordionHeaderSelector: '[data-accordion-header]',
        accordionBodySelector: '[data-accordion-body]',
    });

    this.after('initialize', function() {
        this.on('click', {
            accordionHeaderSelector: this.toggleAccordion,
        });

        this.on('uiAccordionOpen', this.openAccordion);
        this.on('uiAccordionClose', this.closeAccordion);
    });

    this.toggleAccordion = function() {
        if (this.isCollapsed()) {
            this.openAccordion();
        } else {
            this.closeAccordion();
        }
    };

    this.isCollapsed = function() {
        return this.$node[0].hasAttribute('data-accordion-collapse');
    };

    this.openAccordion = function() {
        this.$node.removeAttr('data-accordion-collapse');
    };

    this.closeAccordion = function() {
        this.$node.attr('data-accordion-collapse', true);
    };
}

export default defineComponent(Accordion);



// WEBPACK FOOTER //
// ./src/js/component_ui/accordion.js